module.exports = __webpack_public_path__ + "img/guide_bg.5617bad3.png";